export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-upload-fbd1eb77e662c0db5660d926c59fc249.svg";